module.exports = __webpack_public_path__ + "img/zoom-out.28d987e5.svg";